
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiVesselTypeSpeedCraftFilled as ObiVesselTypeSpeedCraftFilledElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-vessel-type-speed-craft-filled.js';
 
 
 

 
 export const ObiVesselTypeSpeedCraftFilled = createComponent({
   react: React,
   tagName: 'obi-vessel-type-speed-craft-filled',
   elementClass: ObiVesselTypeSpeedCraftFilledElement,
   events: {
     
   }
  });
 
 